'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import l$1 from "../defs/Paperclip.js";
var i = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var p = (r, e, o) => e in r ? i(r, e, { enumerable: true, configurable: true, writable: true, value: o }) : r[e] = o, t = (r, e) => {
  for (var o in e || (e = {}))
    s.call(e, o) && p(r, o, e[o]);
  if (a)
    for (var o of a(e))
      l.call(e, o) && p(r, o, e[o]);
  return r;
}, m = (r, e) => c(r, f(e));
const P = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, m(t({ ref: e }, r), { weights: l$1 })));
P.displayName = "Paperclip";
export {
  P as Paperclip
};
